// @mui material components
import { Card, Divider, Grid } from "@mui/material";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios.js";

function P2PIndex() {
  const pageTitle = "P2P Marketplace";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3} mb={10}>
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-evenly"
        >
          <MDTypography variant="h3">P2P Marketplace</MDTypography>
          <MDTypography mt={2} variant="text" align="center" fontWeight="light">
            Buy and sell foreign currencies, deposit and withdraw funds in PayPal, Skrill, Neteller,
            Payoneer and many more. All at your preferred rates.
          </MDTypography>
        </MDBox>
        <MDBox mt={5}>
          <Divider />
        </MDBox>
        <MDBox mt={5}>
          <Grid
            container
            spacing={4}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={4} lg={4}>
              <Card sx={{ minHeight: "5vw" }}>
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDBox
                    p={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="space-evenly"
                  >
                    <MDTypography variant="h6">Alero Market</MDTypography>
                    <MDTypography variant="caption" align="center" mt={1}>
                      Swap currencies with other alero users at your preferred rates.
                    </MDTypography>
                    <MDTypography variant="caption" align="left" mt={3}>
                      <ul>
                        <li>Verified Peers</li>
                        <li>Buyer / Seller Protection</li>
                        <li>Secure Escrow</li>
                        <li>Instant Fulfillment</li>
                        <li>1% Market Fee</li>
                      </ul>
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    mt={1}
                    p={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    direction="column"
                    justify="center"
                  >
                    <MDButton
                      color="info"
                      variant="contained"
                      sx={{ width: "100%" }}
                      onClick={() => {
                        navigate("/p2p/fx");
                      }}
                    >
                      Proceed
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Card sx={{ minHeight: "5vw" }}>
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDBox
                    p={2}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="space-evenly"
                  >
                    <MDTypography variant="h6">Digital Market</MDTypography>
                    <MDTypography variant="caption" align="center" mt={1}>
                      Swap digital currencies at your preferred rates. Earn commissions when you
                      accept peer requests.
                    </MDTypography>
                    <MDTypography variant="caption" align="left" mt={3}>
                      <ul>
                        <li>Verified Peers</li>
                        <li>Buyer / Seller Protection</li>
                        <li>Secure Escrow</li>
                        <li>Instant Fulfillment</li>
                        <li>2.5% Market Fee</li>
                        <li>1% Commission</li>
                      </ul>
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    mt={1}
                    p={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    direction="column"
                    justify="center"
                  >
                    <MDButton
                      color="info"
                      variant="contained"
                      sx={{ width: "100%" }}
                      onClick={() => {
                        navigate("/p2p/ewallets");
                      }}
                    >
                      Proceed
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default P2PIndex;
